import React from "react";
import "./Avatar.css";

/**
 * Avatar réutilisable : affiche la photo si elle existe, sinon un rond dégradé
 * orange avec les initiales (même logique que les cartes serveurs / Personnel).
 *
 * props : { photo, firstName, lastName, className }
 * - photo : chemin "/images/..." (préfixé par l'URL backend) ; vide/absent => initiales
 * - className : pour ajuster la taille (ex. navAvatar, monCompteAvatar)
 */
function Avatar({ photo, firstName, lastName, className }) {
  const initials = (
    ((firstName || "")[0] || "") + ((lastName || "")[0] || "")
  ).toUpperCase();

  return (
    <div className={"avatar" + (className ? " " + className : "")}>
      <span className="avatarInitials">{initials || "?"}</span>
      {photo ? (
        <img
          className="avatarPhoto"
          src={process.env.REACT_APP_BACKEND_URL + photo}
          alt=""
          onError={(e) => {
            // Si la photo ne charge pas, on révèle les initiales
            e.target.onerror = null;
            e.target.style.display = "none";
          }}
        />
      ) : null}
    </div>
  );
}

export default Avatar;
